import { UsStatesEnumType } from "@libs/api/patients";
import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const HealthPlansApi = {
  getHealthPlanAvailability: async ({
    usState,
  }: {
    usState: UsStatesEnumType;
  }) => {
    const res = await tsRestClient().healthPlans.getHealthPlanAvailability({
      query: { usState },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body.count;
    }

    sendSentryError({
      message:
        "Unexpected response in HealthPlansApi.getHealthPlanAvailability",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
